export default "__VITE_ASSET__DEr65bUC__"